import { Link } from "expo-router";
import { Button } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, XStack, YStack } from "tamagui";
import { useDebouncedCallback } from "use-debounce";

import { api } from "~/utils/api";
import { SearchInput } from "~/components/blocks";
import { usePathIncludes } from "~/hooks";
import { ResearchSortBy } from "../filter";
import { useResearchFilter } from "../filter-context";

export const ResearchHeader = () => {
  const { match } = usePathIncludes();
  const { t } = useTranslation("research");

  const { dispatch } = useResearchFilter();

  const [slice] = api.research.types.useSuspenseQuery(undefined, {
    select: (data) => data.find((item) => match(item.value)),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleSearchInput = useDebouncedCallback(
    (input: string) =>
      dispatch({
        filterName: "search",
        type: "SET_FILTER",
        value: input,
      }),
    300,
  );

  return (
    <YStack
      justifyContent="space-between"
      paddingTop={"$5"}
      paddingBottom={"$7.8"}
      gap={"$3"}
    >
      <XStack alignItems="flex-start" justifyContent="space-between">
        <Text
          fontFamily={"$subtitle"}
          fontWeight={"$6"}
          fontSize={"$7"}
          lineHeight={"$7"}
          color={"$gray-primary-900"}
        >
          {slice?.name}
        </Text>

        <SearchInput maxWidth={400} onChangeText={handleSearchInput} />
      </XStack>

      <XStack alignItems="flex-start" justifyContent="space-between">
        <Link href={`/research/${slice?.value}/create`} asChild>
          <Button variant={"primary"} size="md" rounded={"lg"}>
            {t("research-list-page.create-research-btn")}
          </Button>
        </Link>
        <ResearchSortBy />
      </XStack>
    </YStack>
  );
};
